"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var RadixSwitch = __importStar(require("@radix-ui/react-switch"));
var react_1 = require("@stitches/react");
var stitches_config_1 = require("../stitches.config");
var StyledSwitchRoot = (0, react_1.styled)(RadixSwitch.Root, {
    width: "32px",
    height: "18px",
    borderRadius: "18px",
    padding: "2px",
    boxShadow: stitches_config_1.theme.shadows.shadowSm,
    display: "flex",
    border: "none",
    background: stitches_config_1.theme.colors.gray9,
    "&:hover": {
        background: stitches_config_1.theme.colors.gray10,
    },
    "&[data-state='checked']": {
        background: stitches_config_1.theme.colors.green9,
        "&:hover": {
            background: stitches_config_1.theme.colors.green10,
        },
    },
});
var StyledSwitchThumb = (0, react_1.styled)(RadixSwitch.Thumb, {
    height: "14px",
    width: "14px",
    background: stitches_config_1.theme.colors.white,
    borderRadius: "30px",
    boxShadow: stitches_config_1.theme.shadows.shadowSm,
    "&[data-state='checked']": {
        marginLeft: "auto",
    },
    "&[data-disabled]": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
});
function Switch(props) {
    return ((0, jsx_runtime_1.jsx)(StyledSwitchRoot, __assign({ checked: props.checked, onCheckedChange: props.onChange, disabled: props.disabled }, { children: (0, jsx_runtime_1.jsx)(StyledSwitchThumb, {}) })));
}
exports.Switch = Switch;
//# sourceMappingURL=Switch.js.map